import { combineReducers } from "redux";
import session from "./sessionReducer";
import sso from "./ssoReducer";
import error from "./errorReducer";
import domain from "./domainReducer";
import localCache from "./localCacheReducer";
import common from "./commonReducer";
import prayerFeature from "./prayerFeatureReducer";

let rootReducer = combineReducers({
    domain,
    localCache,
    sso,
    session,
    error,
    common,
    prayerFeature
});
rootReducer.cookiesObject = null;

export default rootReducer;